var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_c('div',{attrs:{"id":"list_menu"}},[_c('router-link',{attrs:{"to":"/uploads/rules"}},[_vm._v("Правила загрузки")]),_c('router-link',{attrs:{"to":"/uploads"}},[_vm._v("Загрузить ADIF")]),_c('router-link',{attrs:{"to":"/uploads/manage"}},[_vm._v("Мои загрузки")])],1),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }